import { isNull } from 'utils/utils';

export const getPopupTitle = (
  customRenderer: any,
  label: string | null | undefined,
  fallback = 'Comment'
) => (customRenderer ? undefined : !isNull(label) ? label : fallback);
